//
// Text overflow
// --------------------------------------------------
import { css } from 'styled-components'; // Requires inline-block or block for proper styling

export var textOverflow = function textOverflow() {
  return css(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
};